/* Al Maleh House — Theme JavaScript */
(function () {
  'use strict';

  /* ----------------------------------------
     Header: transparent → solid on scroll
  ---------------------------------------- */
  var header = document.getElementById('SiteHeader');
  if (header) {
    function onScroll() {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ----------------------------------------
     Mobile menu
  ---------------------------------------- */
  var toggle    = document.getElementById('MobileMenuToggle');
  var closeBtn  = document.getElementById('MobileMenuClose');
  var mobileMenu = document.getElementById('MobileMenu');

  function openMenu() {
    mobileMenu.classList.add('open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.classList.remove('active');
    document.body.style.overflow = '';
    mobileMenu.querySelectorAll('.mobile-nav-item--has-submenu.open').forEach(function (openSubmenu) {
      openSubmenu.classList.remove('open');
      var st = openSubmenu.querySelector('.mobile-submenu-toggle');
      var sl = openSubmenu.querySelector('.mobile-submenu');
      if (st) st.setAttribute('aria-expanded', 'false');
      if (sl) sl.setAttribute('aria-hidden', 'true');
    });
  }

  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function () {
      mobileMenu.classList.contains('open') ? closeMenu() : openMenu();
    });
  }

  if (closeBtn && mobileMenu) {
    closeBtn.addEventListener('click', closeMenu);
  }

  if (mobileMenu) {
    mobileMenu.querySelectorAll('.mobile-nav-link, .mobile-submenu-link').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    /* Close on Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) closeMenu();
    });
  }

  /* ----------------------------------------
     Language selector dropdown
  ---------------------------------------- */
  var langSelector = document.querySelector('.language-selector');
  if (langSelector) {
    var langBtn = langSelector.querySelector('.lang-current');
    if (langBtn) {
      langBtn.addEventListener('click', function () {
        var open = langSelector.classList.toggle('open');
        langBtn.setAttribute('aria-expanded', open);
      });
      document.addEventListener('click', function (e) {
        if (!langSelector.contains(e.target)) {
          langSelector.classList.remove('open');
          langBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  /* ----------------------------------------
     Scroll-reveal animations
  ---------------------------------------- */
  var fadeEls = document.querySelectorAll('.fade-up');
  if ('IntersectionObserver' in window && fadeEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -48px 0px' });
    fadeEls.forEach(function (el) { io.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('visible'); });
  }

  /* ----------------------------------------
     Product image gallery
  ---------------------------------------- */
  var gallery = document.querySelector('.product-gallery');
  if (gallery) {
    var mainImg = gallery.querySelector('.product-main-image img');
    var thumbs  = Array.prototype.slice.call(gallery.querySelectorAll('.product-thumb'));
    var current = 0;

    function goToImage(index) {
      if (!thumbs.length || !mainImg) return;
      index = (index + thumbs.length) % thumbs.length;
      var fullSrc = thumbs[index].dataset.fullSrc;
      if (fullSrc) { mainImg.srcset = ''; mainImg.src = fullSrc; }
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumbs[index].classList.add('active');
      current = index;
    }

    // Thumbnail clicks
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goToImage(i); });
    });

    // Arrow buttons
    var prevBtn = gallery.querySelector('.gallery-arrow--prev');
    var nextBtn = gallery.querySelector('.gallery-arrow--next');
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); goToImage(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); goToImage(current + 1); });

    // Keyboard navigation (arrow keys when gallery is focused)
    gallery.setAttribute('tabindex', '0');
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goToImage(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goToImage(current + 1); }
    });

    // Preload all product images into browser cache
    thumbs.forEach(function (thumb) {
      var src = thumb.dataset.fullSrc;
      if (src) { var img = new Image(); img.src = src; }
    });

    // Touch swipe (mobile)
    var touchStartX = 0;
    var touchStartY = 0;
    var mainWrap = gallery.querySelector('.product-main-image-wrap') || gallery.querySelector('.product-main-image');
    mainWrap.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    mainWrap.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        goToImage(dx < 0 ? current + 1 : current - 1);
      }
    }, { passive: true });
  }

  /* ----------------------------------------
     Hero scroll indicator
  ---------------------------------------- */
  var scrollBtn = document.querySelector('.hero-scroll');
  if (scrollBtn) {
    scrollBtn.addEventListener('click', function () {
      var hero = document.querySelector('.hero');
      if (hero && hero.nextElementSibling) {
        hero.nextElementSibling.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  /* ----------------------------------------
     Active nav link
  ---------------------------------------- */
  document.querySelectorAll('.nav-link').forEach(function (link) {
    if (link.getAttribute('href') === window.location.pathname) {
      link.classList.add('active');
    }
  });

  /* Mark parent "Our Bazaars" link active when on a sub-page */
  document.querySelectorAll('.nav-dropdown-link').forEach(function (link) {
    if (link.getAttribute('href') === window.location.pathname) {
      var parentLink = link.closest('.nav-item--has-dropdown') && link.closest('.nav-item--has-dropdown').querySelector('.nav-link');
      if (parentLink) parentLink.classList.add('active');
    }
  });

  /* ----------------------------------------
     Mobile submenu toggles
  ---------------------------------------- */
  document.querySelectorAll('.mobile-nav-item--has-submenu').forEach(function (item) {
    var btn = item.querySelector('.mobile-submenu-toggle');
    var list = item.querySelector('.mobile-submenu');
    if (btn && list) {
      btn.addEventListener('click', function () {
        var isOpen = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', String(isOpen));
        list.setAttribute('aria-hidden', String(!isOpen));
      });
    }
  });

  /* ----------------------------------------
     Sticky mobile enquire bar — show once the main
     Enquire button has scrolled up out of view
  ---------------------------------------- */
  var enquireBtn = document.getElementById('ProductEnquireBtn');
  var enquireBar = document.getElementById('MobileEnquireBar');
  if (enquireBtn && enquireBar && 'IntersectionObserver' in window) {
    var barControls = enquireBar.querySelectorAll('a, button');
    enquireBar.setAttribute('aria-hidden', 'true');
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      enquireBar.classList.toggle('is-visible', show);
      enquireBar.setAttribute('aria-hidden', String(!show));
      barControls.forEach(function (el) { el.setAttribute('tabindex', show ? '0' : '-1'); });
    }).observe(enquireBtn);
  }

})();
